import React from 'react'

function FormInputGroup({ text, placeholder, value, onInput, onKeyUp, readOnly = false, type = 'number' }) {
  return (


    <div className="form-group">
      <label style={{ fontSize: '12px', color: '#17406b', marginBottom: '5px' }}>{text}</label>
      
      <input className="form-control"
        type={type}
        placeholder={placeholder}
        value={value}
        onInput={onInput}
        onKeyUp={onKeyUp}
        readOnly={readOnly}
        style={{ marginBottom: '15px' }} />

    </div>

  )
}


export default FormInputGroup